import { render, staticRenderFns } from "./getForensicsimg.vue?vue&type=template&id=795cfedf&scoped=true"
import script from "./getForensicsimg.vue?vue&type=script&lang=js"
export * from "./getForensicsimg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795cfedf",
  null
  
)

export default component.exports